module.exports = __webpack_public_path__ + "static/media/home-bgi-blue.1b4f3b19.png";